module.exports = __webpack_public_path__ + "img/descImg2.83015ea3.png";